/**
 * Executor for rebooking API calls
 */
import { useErrorStore } from '../../stores/errorStore'
import {
  rebookItems as apiRebookItems,
  fetchBookingData,
} from '../../services/journeyService'
import {
  transformBookingData,
  checkIfBookingHasSeats,
} from '../../utils/rebooking/dataTransformUtils'

/**
 * Executes the rebooking API call with the prepared request
 */
export const rebookJourney = async (
  bookingNumber: string,
  apiRequest: any
) => {
  const errorStore = useErrorStore()
  
  try {
    console.log('[REBOOK-EXECUTOR] Starting rebooking API call:', { bookingNumber })
    
    // Make the API call to rebook items
    await apiRebookItems(bookingNumber, apiRequest)
    console.log('[REBOOK-EXECUTOR] Rebooking API call completed successfully')
    
    // Fetch updated booking data after rebooking
    console.log('[REBOOK-EXECUTOR] Fetching updated booking data after rebooking')
    const updatedResponse = await fetchBookingData(bookingNumber, true)
    const updatedBookingData = updatedResponse?.data?.booking
    
    if (!updatedBookingData) {
      throw new Error('Failed to fetch updated booking data after rebooking')
    }
    
    console.log('[REBOOK-EXECUTOR] Raw booking data fetched:', {
      hasOutboundSegments: !!updatedBookingData.outbound_booking_tariff_segments,
      outboundSegmentsCount: updatedBookingData.outbound_booking_tariff_segments?.length || 0,
      hasInboundSegments: !!updatedBookingData.inbound_booking_tariff_segments,
      inboundSegmentsCount: updatedBookingData.inbound_booking_tariff_segments?.length || 0,
      firstOutboundRequiredProducts: updatedBookingData.outbound_booking_tariff_segments?.[0]?.required_products?.length || 0
    })
    
    // Transform booking data for the UI
    console.log('[REBOOK-EXECUTOR] About to transform booking data')
    const transformedBookingData = transformBookingData(updatedBookingData)
    console.log('[REBOOK-EXECUTOR] Booking data transformation completed')
    
    return {
      bookingData: transformedBookingData,
      hasSeats: checkIfBookingHasSeats(updatedBookingData)
    }
  } catch (error) {
    console.error('Error during rebooking API call:', error)
    let errorMessage = 'Failed to execute rebooking'
    
    if (error instanceof Error) {
      errorMessage = error.message || errorMessage
    }
    
    errorStore.setError(errorMessage)
    throw error
  }
}
